document.addEventListener('DOMContentLoaded', () => {
	const formContainer = document.querySelector('.shopify-app-block');
	const observer = new MutationObserver((mutationsList, observer) => {
		const form = document.querySelector('#app-embed');
		if (form) {
			observer.disconnect();
			const shadow = form.shadowRoot;
			const sheet = new CSSStyleSheet();
			sheet.insertRule(`
				:host {
					--form-field-border-radius:0;
					--button-border-radius:24px;
					--form-background-color:#eceff1;
					--form-field-border:none;
					--button-padding:22px 44px;
					--button-border-radius:30px;
					--forms-body-font:normal 400 16px "Noto Sans", sans-serif;
					--button-background-color-hovered-modifier:brightness(0.9);
					--inline-container-max-width: 860px;
				}
			`);
			sheet.insertRule(`
				button[type="submit"] {
					position:relative;
					--forms-body-font:normal 700 16px "Noto Sans", sans-serif;
					align-self:center;
					color:var(--color-black);
					background:none;
				}
			`);
			sheet.insertRule(`
				button[type="submit"]::before {content:""; display:block; width:100%; height:100%; position:absolute; z-index:-1; left:0; top:0; transform:translate(5px, 5px); background:var(--secondary); border-radius:30px; transition:transform 0.3s, background 0.3s;}
			`);
			sheet.insertRule(`
				button[type="submit"]:hover::before {transform:translate(3px, 3px); background:#1cb9a2;}
			`);
			sheet.insertRule(`
				button[type="submit"]::after {content:""; display:block; width:100%; height:100%; position:absolute; z-index:1; left:0; top:0; border-radius:30px; box-sizing:border-box; border:2px solid var(--color-foreground);}
			`);
			sheet.insertRule(`
				.phone-country-selector button {
					max-height:none;
				}
			`);
			shadow.adoptedStyleSheets.push(sheet);
			formContainer.classList.add('loaded');
		};
	});
	observer.observe(document.body, { childList:true, subtree:true });
});